module.exports = __webpack_public_path__ + "img/documenPage.88c05a86.jpg";